// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import moment from 'moment-timezone';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import '../../../styles/components/PartiesList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import UserPartiesMobile from './UserPartiesMobile';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const UserParties = ({ content, user, handleOnClick, changeRole }) => {
  const localTz = moment.tz.guess();

  const onPartyClick = event => {
    event.preventDefault();
    handleOnClick(event.currentTarget.getAttribute('href'));
  };

  const onRoleSelect = (value, party) => {
    changeRole(value, party);
  };

  const getPartyDates = item => {
    const tz = item.tz ? item.tz : localTz;
    return item.startDate
      ? `${moment(item.startDate).tz(tz).format('MM/DD/YY')} - ${moment(
          item.endDate
        )
          .tz(tz)
          .format('MM/DD/YY z')}`
      : 'none';
  };

  const getMember = item => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    return item.members.find(memb => memb.memberId === user.id);
  };

  const memberOptions = [
    { value: 'bach', label: 'BACH' },
    { value: 'planner', label: 'Planner' },
    { value: 'guest', label: 'Guest' },
  ];

  if (isMobileResolution()) {
    return (
      <UserPartiesMobile
        content={content}
        onPartyClick={onPartyClick}
        getPartyDates={getPartyDates}
        getMember={getMember}
        onRoleSelect={onRoleSelect}
        memberOptions={memberOptions}
      />
    );
  }
  return (
    <div className='partieslist'>
      <Table hover>
        <thead>
          <tr>
            <th>Party Location</th>
            <th>Party Dates</th>
            <th>Party Name</th>
            <th>Member Name</th>
            <th>Member DOB</th>
            <th>Member Phone</th>
            <th>Member Venmo Handle</th>
            <th>Relationship to BACH</th>
            <th>Itinerary Suggestions</th>
            <th>Member Role</th>
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {content.map(item => {
            const tz = item.tz ? item.tz : localTz;
            const member = getMember(item);
            return (
              <tr
                key={item.partyId}
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                href={`/party/${item.partyId}`}
                className='listrow'
                onClick={onPartyClick}
              >
                <td>
                  {item.partyLocation ? item.partyLocation.address : 'none'}
                </td>
                <td>{getPartyDates(item)}</td>
                <td>{item.partyName}</td>
                <td>{member.memberName}</td>
                <td>
                  {member.memberDOB
                    ? moment(member.memberDOB).tz(tz).format('MM/DD/YY')
                    : ''}
                </td>
                <td>{member.memberPhone ? member.memberPhone : ''}</td>
                <td>{member.memberVenmo}</td>
                <td>{member.memberAcquaintance}</td>
                <td>{member.memberFeedback}</td>
                <td>
                  <div onClick={e => e.stopPropagation()}>
                    <SimpleSelect
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      onChange={onRoleSelect}
                      value={member.memberRole}
                      name={item.partyId}
                      data={memberOptions}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default React.memo(UserParties);
